// services/activity.service.ts

export interface ActivityEntry {
  txHash: string;
  action: "deposit" | "withdraw" | "swap" | "claim" | "fund" | "deploy";
  strategyId?: string;
  amounts?: {
    usdc?: number;
    xlm?: number;
    aquaLp?: number;
    soroswapLp?: number;
  };
  status: "success" | "error";
  errorMessage?: string;
  timestamp: string; // ISO string from backend
}

/**
 * Record a transaction activity entry.
 * Best-effort: silently swallows failures so the TX flow is never interrupted.
 */
export async function recordActivity(
  entry: Omit<ActivityEntry, "timestamp">,
): Promise<void> {
  try {
    await fetch("/api/auth/activity", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(entry),
    });
  } catch {
    // Best-effort — don't break the TX flow if activity recording fails
  }
}

/**
 * Fetch all activity entries for the current user.
 * Returns an empty array on any error.
 */
export async function fetchActivity(): Promise<ActivityEntry[]> {
  try {
    const res = await fetch("/api/auth/activity");
    if (!res.ok) return [];
    const data = (await res.json()) as { activity: ActivityEntry[] };
    return data.activity;
  } catch {
    return [];
  }
}
